import { Flex } from 'antd'
import React from 'react'

const NavBar = () => {
  return (
    <Flex style={{padding: '2rem'}} justify='center'>
        <img src='https://thummimng.com/wp-content/uploads/2022/08/logo-full_fyjwy0-1.png' className='logo' />
    </Flex>
  )
}

export default NavBar